module.exports = __webpack_public_path__ + "static/media/a-new-hope.66809297.png";